<template>
  <div class="">
    <v-header ref="dudu"></v-header>
    <div class="beijngsd">
      <span></span>
      个人中心
      <span></span>
    </div>
    <div class="manpin">
      <div class="main centen container">
        <leftmenu ref="leftmenu"></leftmenu>
        <!-- 在class为main_r里面写页面就行 -->
        <div class="main_r">
          <div class="mainr_top">
            <img src="../images/geren16.png">我的关注
          </div>
          <!-- 我的关注 -->
          <ul class="guanzhuTab">
            <li :class="{active:zhuanye == 3}" @click="qirhuan(3)">
              <router-link to="">院校分</router-link>
            </li>
            <li :class="{active:zhuanye == 4}" @click="qirhuan(4)">
              <router-link to="">专业分</router-link>
            </li>
          </ul>
          <div class="guanzhuList" v-if="zhuanye == 3" style="background: #FFFFFF;border: 0px;">
            <div v-for="(item,index) in list" class="item">
              <div class="t1 flex-between" style="padding-bottom: 0px;">
                <h4 style="display: flex;flex-direction: row; ">
                  <div v-if="item.obj.college_code!=null&&item.obj.college_code!=''&&$utils.getlocalStorage('showcode')"
                  class="mycode">
                    {{item.obj.college_code}}
                  </div>
                  <router-link tag="a" target="_blank" :to="'/xyzy_jianjie?num=0&id='+item.obj.college_id">
                    {{item.obj.college_name}}</router-link>

                  <span v-if="getempty(item.obj.college_info)!='--'">{{item.obj.college_info}}</span>
                </h4>
                <icollege :item="item"></icollege>
                <div class="jh" style="margin-left: 15px;" v-if="tianbaoType==2">专业分组：<span style="color: #F53824;">{{getempty(item.obj.group_name)}}</span></div>
                <div class="jh" style="margin-left: 15px;">当年计划：<span style="color: #F53824;">{{getempty(item.obj.plan_num)}}</span></div>

                <div class="flex-items">
                  <time>关注时间：{{item.creat_time}}</time>
                  <div class="btn po-r">
                    <a class="shoucangBtn">已关注</a>
                    <a class="shoucangBtn qxshoucangBtn" @click="quxiao(item.obj.plan_id,3,index)">取消关注</a>
                  </div>
                </div>
              </div>
              <div class="t2 flex-between" style="padding-bottom: 0px;">

                <div class="flex-items">
                  <div class="ke" style="font-size: 14px;margin-left: 15px;">
                    <span>{{AREA_OBJ[item.obj.college_area]}} /
                          {{ item.obj.college_subject }} /
                          <span :style="{color:item.obj.college_nature == 1?'':'red'}">{{item.obj.college_nature == 1?'公立':'民办'}}</span>
                          <span v-if="item.college!=null&&item.college.area!=null"> / {{ item.college.area }}</span>
                          </span>
                  </div>
                </div>
                <div class="flex-end">
                  <!-- <a  class="zy">查看专业</a> -->
                </div>
              </div>

              <div class="t2 flex-between" v-if="tianbaoType==1" style="padding-bottom: 0px;">
                <div class="flex-items">

                  <h4 style="display: flex;flex-direction: row; ">
                    <div v-if="item.obj.major_code!=null&&item.obj.major_code!=''&&$utils.getlocalStorage('showcode')"
                    style="background-color: #F53824;border-radius: 10px;
                    color: white;    font-size: 14px;
                    line-height: 22px;
                    padding: 0px 10px;
                    margin-right: 10px;"

                    >
                      {{item.obj.major_code}}
                    </div>
                    <router-link tag="a" target="_blank" :to="'/zyxq_zhuanyejieshao?id='+item.obj.major_id">
                      {{item.obj.major_name}}</router-link>

                    <!-- <span v-if="getempty(item.obj.college_info)!='--'">{{item.obj.college_info}}</span> -->
                  </h4>
                  <imajor style="margin-left: 20px;" :item="item"></imajor>

                </div>
              </div>
              <div class="t2 flex-between" style="padding-bottom: 0px;" v-if="getempty(item.obj.major_info)!='--'">
                <div class="flex-items">
                  <div class="ke" style="font-size: 14px;margin-left: 15px;">
                    {{item.obj.major_info}}
                  </div>
                </div>
              </div>

              <div class="listBox" style="padding-bottom: 0px;">
                <dl v-for="(score,index) in item.list" v-if="item.list" style="margin-bottom: 5px;">
                  <dt>{{score.scoreYear}}年</dt>
                  <dd>录取数：{{score.scorePlanNum}}</dd>
                  <dd>最低分：{{score.scoreMin}}</dd>
                  <dd v-if="showflag">等效分：{{score.spare1}}</dd>
                  <dd>等位分：{{score.spare2}}</dd>
                  <dd>位次：{{score.scoreMinRank}}</dd>

                  <dd>分差：
                  <span  :style="{color:$utils.getScorecolor(myscore.score,score.spare2,1)}">
                  {{ $utils.getScoreCha(myscore.score,score.spare2,1) }}</span>
                  </dd>
                  <dd>位差：
                  <span  :style="{color:$utils.getScorecolor(myscore.scoreRank,score.scoreMinRank,0)}">
                  {{ $utils.getScoreCha(myscore.scoreRank,score.scoreMinRank,0) }}</span>
                  </dd>
                </dl>
              </div>
            </div>

          </div>
          <!-- 专业 -->
          <div class="" v-if="zhuanye == 4">
            <div class="guanzhuList" v-for="(item,index) in list">
              <div class="t1 flex-between" style="padding-bottom: 0px;">
                <h4 style="display: flex;flex-direction: row; ">
                  <div v-if="item.obj.college_code!=null&&item.obj.college_code!=''&&$utils.getlocalStorage('showcode')"
                  class="mycode">
                    {{item.obj.college_code}}
                  </div>
                  <router-link tag="a" target="_blank" :to="'/xyzy_jianjie?num=0&id='+item.obj.college_id">
                    {{item.obj.college_name}}</router-link>
                  <span v-if="getempty(item.obj.college_info)!='--'">{{item.obj.college_info}}</span>

                </h4>
                <icollege :item="item" style="margin-right: 20px;margin-top: 5px;"></icollege>
                <div class="jh" style="margin-left: 40px;">当年计划：<span style="color: #F53824;">{{getempty(item.obj.plan_num)}}</span></div>
                <div class="flex-items">
                  <time>关注时间：{{item.creat_time}}</time>
                  <div class="btn po-r">
                    <a class="shoucangBtn">已关注</a>
                    <a class="shoucangBtn qxshoucangBtn" @click="quxiao(item.obj.plan_id,4,index)">取消关注</a>
                  </div>
                </div>
              </div>
              <div class="t2 flex-between" style="padding-bottom: 0px;">

                <div class="flex-items">

                  <div class="ke" style="font-size: 14px;margin-left: 15px;">
                    <span>{{AREA_OBJ[item.obj.college_area]}} /
                          {{ item.obj.college_subject }} /
                          <span :style="{color:item.obj.college_nature == 1?'':'red'}">{{item.obj.college_nature == 1?'公立':'民办'}}</span>
                          <span v-if="item.college!=null&&item.college.area!=null"> / {{ item.college.area }}</span>
                          </span>
                  </div>
                </div>
              </div>
              <div class="listBox flex-items">
                <div class="text">
                  <h4 style="display: flex;flex-direction: row; place-items: center;">
                    <div v-if="item.obj.major_code!=null&&item.obj.major_code!=''&&$utils.getlocalStorage('showcode')"
                    class="mycode">
                      {{item.obj.major_code}}
                    </div>
                  <router-link tag="a" target="_blank" :to="'/zyxq_zhuanyejieshao?id='+item.obj.major_id">
                                        {{item.obj.major_name}}</router-link>
				  <span style="margin-left:50px;font-size: 14px; color:#F53824;" v-if="item.obj.study_money!=null">
				    学费 : {{item.obj.study_money}}
				  </span>
                  <span style="font-size: 14px;color: #F53824;margin-left: 10px;" v-if="item.obj.group_name!=null&&item.obj.group_name!=''&&$utils.getlocalStorage('showcode')">
                    分组：{{getempty(item.obj.group_name)}}</span>
                    <imajor :item="item" style="margin-left: 10px;"></imajor>
                    </h4>
                  <p v-if="getempty(item.obj.major_info)!='--'">{{item.obj.major_info}}</p>
                </div>
                <div class="tableBox" v-if="item.list">
                  <table>
                    <tr>
                      <th>年份</th>
                      <th>录取数</th>
                      <th>最低分</th>
                      <th>等效分</th>
                      <th v-if="showflag">等位分</th>
                      <th>位次</th>
                      <th>分差</th>
                      <th>位差</th>
                    </tr>
                    <!-- <tobody v-if="item.list" style="width: 100%;"> -->
                      <tr v-for="(score,index) in item.list" v-if="item.list"  style="width: 100%;">
                        <td>{{getempty(score.scoreYear)}}</td>
                        <td>{{getempty(score.scorePlanNum)}}</td>
                        <td>{{getempty(score.scoreMin)}}</td>
                        <td v-if="showflag">{{getempty(score.spare1)}}</td>
                        <td>{{getempty(score.spare2)}}</td>
                        <td>{{getempty(score.scoreMinRank)}}</td>
                        <td><span  :style="{color:$utils.getScorecolor(myscore.score,score.spare2,1)}">
                        {{ $utils.getScoreCha(myscore.score,score.spare2,1) }}</span></td>
                        <td><span  :style="{color:$utils.getScorecolor(myscore.scoreRank,score.scoreMinRank,0)}">
                        {{ $utils.getScoreCha(myscore.scoreRank,score.scoreMinRank,0) }}</span></td>
                      </tr>
                      <tr v-for="(score,index) in (3-item.list.length)" v-if="item.list">
                        <td>--</td>
                        <td>--</td>
                        <td>--</td>
                        <td>--</td>
                        <td>--</td>
                      </tr>
                      <tr v-for="(score,index) in 3" v-if="!item.list">
                        <td>--</td>
                        <td>--</td>
                        <td>--</td>
                        <td>--</td>
                        <td>--</td>
                      </tr>
                    <!-- </tobody> -->

                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <item7></item7>
  </div>
</template>

<script>
  import vHeader from '../../components/vHeader.vue'
  import item7 from '../../components/item7.vue'
  import leftmenu from '../../components/leftmenu.vue'
  import icollege from '../../components/icollege.vue'
  import imajor from '../../components/imajor.vue'
  export default {
    name: "",
    components: {
      vHeader,
      item7,
      leftmenu,
      icollege,
      imajor
    },
    data() {
      return {
        zhuanye: 3,
        list: [],
        areaObj: this.$utils.getlocalStorage("AREA_OBJ"),
        tianbaoType: this.$utils.getlocalStorage("tianbaoType"),
        userInfo: this.$utils.getlocalStorage('userInfo'),
        AREA_OBJ: this.$utils.getlocalStorage("AREA_OBJ"),
        showflag:false,
        myscore: this.$utils.getlocalStorage("scoreInfo"),
      }
    },
    methods: {
      getData() {
        console.log(11)
        let _this = this;
        _this.$req.queryAllByLimitInfoScore({
          pageSize: _this.pageSize,
          pageNum: _this.pageNum,
          queryObj: {
            dataType: this.zhuanye,
            isdelete: this.$utils.getlocalStorage("areaInfo").areaId,
            id: this.tianbaoType,
            userId:this.$utils.getlocalStorage('userInfo').userId
          }
        }).then(function(response) {
          if(response.data){
			   // _this.list = _this.list.concat(response.data)
			   // _this.total = response.pages;
            let ids = '';
            let list = response.data;
            if(list!=null){
              let newArray = list.map(obj => {
                  return obj.data_id;
              });
              ids = newArray.join(",")
            }


            _this.showflag = parseInt(_this.$utils.getlocalStorage("userInfo").userRole)==3||parseInt(_this.$utils.getlocalStorage("userInfo").userRole)==2
            if(ids!=null&&ids!=''){
              _this.$req.queryAllByLimitScoreInfo({
                pageSize: _this.pageSize,
                pageNum: _this.pageNum,
                queryObj: {
                  dataId:ids,
                  isdelete: parseInt(_this.userInfo.userProvinces),
                  dataType:_this.zhuanye,
                  id: _this.tianbaoType,
                }
              }).then(function(response) {
                  let li = [];
                  list.forEach(function (e){
                    if(response.data[e.data_id]){
                      e.obj = response.data[e.data_id].obj
                      e.list = response.data[e.data_id].list
                      e.college = response.data[e.data_id].college
                      e.major = response.data[e.data_id].major
                      li.push(e)
                    }

                  })
                  _this.list = li
              })
            }
            _this.total = response.pages;
          }
        })
      },
      quxiao(id, type, index) {
        let _this = this;
        let obj = this.$utils.getlocalStorage("userCang")
        let list = [];
        let name = 'collegescore';
        if (type == 4) {
          name = 'majorscore'
        }
        let query = {
          data_type: type,
          data_id: id
        }
        if(this.userInfo.userRole == 3||this.userInfo.userRole == 2){
          query.userId = this.userInfo.userId
        }
        _this.$req.batchDelete("collectionTable", query).then(function(resp) {
          if (resp.status == 0) {
            list = obj[name]
            list.splice(list.indexOf(id), 1);
            obj[name] = list
            _this.list.splice(index, 1)
            _this.$utils.setlocalStorage("userCang", obj);
            _this.$refs.leftmenu.getData()
          }
        })
      },
      getempty(str) {
        if (str == null || str == '' || str + '' == 0) {
          return '--';
        }
        return str;
      },
      qirhuan(opie) {
        console.log(opie)
        this.zhuanye = opie
        this.pageNum = 1;
        this.total = 0;
        this.list = []
        this.getData()
      },
    },
    created() {
      this.getData()
    }
  }
</script>

<style scoped>
  .guanzhuTab li.active a {     background: rgb(249 118 105 / 39%);      color: #F53824;
  }
  .guanzhuTab li a {
    outline: none;
  }

  .item {
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid #E0E0E0;
    border-radius: 10px;
    background: linear-gradient(180deg, #EEFFFE 0%, #FFFFFF 100%);
    box-shadow: 0px 0px 2px #54f3ea;
  }

  /* 退出登录 */
  .tuichuden {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.8);
  }

  .annou {
    display: flex;
    flex-direction: column;
    width: 380px;
    height: 229px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 20px;
    padding: 0 21px;
    box-sizing: border-box;
  }

  .annou h1 {
    width: 100%;
    height: 48px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #29A7E1;
    opacity: 1;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  .annou p {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    flex: 1;
  }

  .annou dl {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .annou dl dt {
    cursor: pointer;
    width: 140px;
    height: 46px;
    background: rgba(200, 200, 200, 1);
    opacity: 1;
    border-radius: 23px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .annou dl dd {
    cursor: pointer;
    width: 140px;
    height: 46px;
    background: linear-gradient(129deg, #F53824 0%, #F44F25 61%, #F45D26 100%);
    box-shadow: 0px 0px 10px #F53824;
    opacity: 1;
    border-radius: 24px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .beijngsd {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100px;
    margin-top: 70px;
    background: url(../../assets/gerenzhongxin/geren21.png)no-repeat;
    background-size: 100% 100%;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
  }

  .beijngsd span {
    display: flex;
    width: 44px;
    height: 2px;
    opacity: 0.48;
    border-radius: 1px;
    background-color: #FFFFFF;
  }

  .beijngsd span:nth-of-type(1) {
    margin-right: 14px;
  }

  .beijngsd span:nth-of-type(2) {
    margin-left: 14px;
  }

  .centen {
    width: 1280px;
    margin: 0 auto;
  }

  .manpin {
    width: 100%;
    height: auto;
    padding: 40px 0;
    box-sizing: border-box;
    background: #ebeef5d6;
  }

  .main {
    padding-bottom: 40px;
    display: flex;
    justify-content: space-between;
  }

  .main_l {
    background: rgba(251, 251, 251, 1);
    width: 210px;
  }

  .topxiang {
    width: 100%;
    height: 194px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    margin-bottom: 30px;
  }

  .topxiang img {
    width: 102.73px;
    height: 102.73px;
    margin-bottom: 20px;
  }

  .topxiang span {
    width: 144px;
    height: 22px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    opacity: 1;
  }

  .jibenxinxi {
    width: 290px;
    height: 700px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 5px;
  }

  .jibenxinxi figure {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .jibenxinxi figure img {
    height: 44px;
    margin-left: 22px;
  }

  .jibenxinxi figure figcaption {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    margin-left: 10px;
  }

  .beijngsdtu {
    background: url(../../assets/gerenzhongxin/geren26.png)no-repeat;
    background-size: 100% 100%;
  }

  .texts {
    color: #F53824 !important;
  }

  .xiaoxi {
    margin-left: 10px;
    background: url(../../assets/gerenzhongxin/geren18.png)no-repeat;
    background-size: 100% 100%;
    width: 33px;
    height: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .main_r {
    width: 1050px;
    /* height: 878px; */
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
  }

  .mainr_top {
    width: 100%;
    height: 68px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.10196078431372549);
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }

  .mainr_top img {
    width: 7px;
    height: 24px;
    margin-right: 10px;
  }

  .youxinxi {
    padding: 33px 20px 0 20px;
    width: 310px;
    height: 230px;
    background: rgba(253, 251, 247, 1);
    border: 1px solid #FBF5E9;
    opacity: 1;
    border-radius: 5px;
    position: absolute;
    top: 24px;
    right: 20px;
  }

  .mainr_bot {
    width: 100%;
    position: relative;
  }

  .youxinxi label {
    position: absolute;
    top: -14px;
    left: 20px;
    width: 92px;
    height: 28px;
    background: rgba(244, 166, 65, 1);
    opacity: 1;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .youxinxi figure {
    display: flex;
    margin-bottom: 13px;
  }

  .youxinxi figure img {
    margin-right: 4px;
    width: 18px;
    height: 20px;
  }

  .youxinxi figure figcaption {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #5A4F40;
  }

  .form {
    width: auto;
    height: auto;
    display: flex;
    flex-direction: column;
    margin-top: 30px;
    margin-left: 40px;
  }

  .form li {
    width: auto;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    position: relative;
  }

  .form li label {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    width: 80px;
    text-align: right;
  }

  .form li i {
    color: #F53824;
    margin: 0 5px;
  }

  .form li input {
    width: 372px;
    height: 40px;
    background: rgba(255, 255, 255, 0.39);
    border: 1px solid #E0E0E0;
    opacity: 1;
    border-radius: 5px;
    padding: 0 10px;
    box-sizing: border-box;

  }

  .duanxin {
    border: none;
    position: absolute;
    top: 5px;
    left: 240px;
    width: 120px;
    height: 30px;
    background: linear-gradient(180deg, #F53824 0%, #F45D26 100%);
    opacity: 1;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .shoujiinp {
    width: auto;
    display: flex;
    position: relative;
  }

  .form li {
    position: static;
  }

  /* .form li .shoujiinp input{width: auto;} */
  .form li .shoujiinp span {
    margin-top: 5px;
  }

  .form li span {
    margin-left: 5px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #F53824;
    opacity: 1;
  }

  .inps {
    width: 118px;
    height: 40px;
  }

  .inps:nth-of-type(1) {
    margin-right: 9px;
  }

  .inps:nth-of-type(2) {
    margin-right: 9px;
  }

  .inpda {
    width: 372px;
    height: 40px;
    background: rgba(255, 255, 255, 0.39);
    opacity: 1;
  }

  .baochuan {
    border: none;
    margin-left: 115px;
    margin-top: 20px;
    width: 140px;
    height: 46px;
    background: linear-gradient(92deg, #F53824 0%, #F45D26 100%);
    opacity: 1;
    border-radius: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }
  .mycode{
    background-color: #F53824;
    border-radius: 10px;
    color: white;
    font-size: 14px;
    line-height: 22px;
    height: 22px;
    padding: 0px 10px;
    margin-right: 10px;
  }


  @media (min-width:750px) {
    .mainr_bot2 {
      display: none;
    }
  }

  @media (max-width:750px) {
    .mainr_bot {
      display: none;
    }

    .beijngsd {
      height: 70px;
      font-size: 24px;
    }

    .main {
      flex-direction: column;
    }

    .main_l {
      width: 100%;
    }

    .jibenxinxi::-webkit-scrollbar {
      display: none;
    }

    .manpin {
      padding: 20px 0;
    }

    .topxiang {
      flex-direction: row;
      width: 100%;
      height: auto;
      justify-content: revert;
      margin-bottom: 15px;
    }

    .topxiang span {
      margin-left: 20px;
    }

    .topxiang img {
      margin: 0;
      height: 60px;
      width: 60px;
    }

    .jibenxinxi {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: row;
      overflow-y: hidden;
      overflow: auto;
      background: whitesmoke;
    }

    .jibenxinxi figure {
      flex-shrink: 0;
      width: auto;
      margin: 0 5px;
    }

    .beijngsdtu {
      /* background: url(../../assets/gerenzhongxin/sj_geren26.png)no-repeat; */
      background: none;
      /* background-size: 100% 100%; */
      border-bottom: 1px solid #F53824;
    }

    .jibenxinxi figure img {
      margin-left: 0;
    }

    .youxinxi2 {
      padding: 33px 20px 0 20px;
      width: 100%;
      height: 230px;
      background: rgba(253, 251, 247, 1);
      border: 1px solid #FBF5E9;
      opacity: 1;
      border-radius: 5px;
      position: relative;
    }

    .mainr_bot2 {
      width: 100%;
      margin-top: 20px;
      /* position: relative; */
    }

    .youxinxi2 label {
      position: absolute;
      top: -14px;
      left: 20px;
      width: 92px;
      height: 28px;
      background: rgba(244, 166, 65, 1);
      opacity: 1;
      border-radius: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
    }

    .youxinxi2 figure {
      display: flex;
      margin-bottom: 13px;
    }

    .youxinxi2 figure img {
      margin-right: 4px;
      width: 18px;
      height: 20px;
    }

    .youxinxi2 figure figcaption {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #5A4F40;
    }

    .main_r {
      width: 100%;
      display: flex;
      flex-direction: column;
    }


    .form {
      margin-left: 0;
    }

    .shoujiinp {
      flex: 1;
      display: flex;
      flex-direction: column;
      position: relative;
    }

    .form li {
      position: static;
    }

    .form li .shoujiinp input {
      width: auto;
    }

    .form li .shoujiinp span {
      margin-top: 5px;
    }

    .form li label {
      flex-shrink: 0;
    }

    .duanxin {
      right: 10px;
      left: auto;
      top: 5px;
      width: 85px;
      border-radius: 5px;
      font-size: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/mine/f_wdguanzhu.vue